<template>
  <div class="navmenu">
    <svg-icon
      class="logo"
      icon-class="xrk-logo"
      @click="handleSelect('home', ['home'])"
    />
    <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      @select="handleSelect"
      background-color="#3c3e42"
      text-color="#dfe1e3"
      active-text-color="#ff792e"
      class="nav-bar-menu"
    >
      <el-menu-item index="home" :class="{ isactive: activeIndex == 'home' }">
        <div class="menu-title">
          <div class="title-text">我的工作台</div>
          <div class="active-line"></div>
        </div>
      </el-menu-item>
      <el-menu-item
        index="temps"
        v-if="permissions['WeiXinPushMessage']"
        :class="{ isactive: activeIndex == 'temps' }"
      >
        <div class="menu-title">
          <div class="title-text">消息管理</div>
          <div class="active-line"></div>
        </div>
      </el-menu-item>
      <el-menu-item
        v-if="permissions.Estate"
        index="estate"
        :class="{ isactive: activeIndex == 'estate' }"
      >
        <div class="menu-title">
          <div class="title-text">楼盘管理</div>
          <div class="active-line"></div>
        </div>
      </el-menu-item>
      <el-menu-item index="ads" :class="{ isactive: activeIndex == 'ads' }" v-if="permissions.Advert">
        <div class="menu-title">
          <div class="title-text">广告管理</div>
          <div class="active-line"></div>
        </div>
      </el-menu-item>
      <el-menu-item
        v-if="permissions.Information"
        index="information"
        :class="{ isactive: activeIndex == 'information' }"
      >
        <div class="menu-title">
          <div class="title-text">资讯管理</div>
          <div class="active-line"></div>
        </div>
      </el-menu-item>
      <el-menu-item
        v-if="permissions.Reservation"
        index="reservation"
        :class="{ isactive: activeIndex == 'reservation' }"
      >
        <div class="menu-title">
          <div class="title-text">报备管理</div>
          <div class="active-line"></div>
        </div>
      </el-menu-item>
      <!-- <el-submenu
        index="transaction"
        v-if="permissions.Transaction"
        :class="{ 'isactive': activeIndex == 'transaction' }"
      >
        <template slot="title">
          <div class="menu-title">
            <div class="title-text">交易管理</div>
            <div class="active-line"></div>
          </div>
        </template>
        <div class="menu-box">
          <div class="menu-item">
            <el-menu-item
              :class="{ 'isactive': activeRoute == 'mine' }"
              index="transactionMine"
              >我的交易</el-menu-item
            >
            <el-menu-item
              :class="{ 'isactive': activeRoute == 'achievement' }"
              index="achievementPlan"
              >业绩分成</el-menu-item
            >
            <el-menu-item
              ref="commissionRoute"
              :class="{ 'isactive': activeRoute == 'commission' }"
              index="commission"
              >结佣管理</el-menu-item
            >
          </div>
        </div>
      </el-submenu> -->
      <el-menu-item
        v-if="permissions.Customer"
        index="customer"
        :class="{ isactive: activeIndex == 'customer' }"
      >
        <div class="menu-title">
          <div class="title-text">客源管理</div>
          <div class="active-line"></div>
        </div>
      </el-menu-item>
      <el-submenu
        index="channel"
        v-if="
          permissions['Company'] ||
          permissions['Company.Stores'] ||
          permissions['RocketIdentity.Users'] ||
          permissions['RocketIdentity.Positions'] ||
          permissions['RocketIdentity.OrganizationUnits']
        "
        :class="{ isactive: activeIndex == 'channel' || activeIndex == 'hr' }"
      >
        <template slot="title">
          <div class="menu-title">
            <div class="title-text">分销商管理</div>
            <div class="active-line"></div>
          </div>
        </template>
        <div class="menu-box">
          <div
            class="menu-item"
            v-if="
              permissions['Company'] ||
              permissions['Company.Stores'] ||
              permissions['RocketIdentity.Users']
            "
          >
            <div class="menu-title">分销商</div>
            <el-menu-item
              v-if="permissions['Company']"
              :class="{ isactive: activeRoute == 'business' }"
              index="channelBusiness"
              >分销商</el-menu-item
            >
            <el-menu-item
              v-if="permissions['Company.Stores']"
              :class="{ isactive: activeRoute == 'franchisee' }"
              index="channelFranchisee"
              >分销商门店</el-menu-item
            >
            <el-menu-item
              :class="{ isactive: activeRoute == 'employe' }"
              index="employe"
              v-if="permissions['RocketIdentity.Users']"
              >分销人员</el-menu-item
            >
          </div>
          <div
            class="menu-item"
            v-if="
              permissions['RocketIdentity.Positions'] ||
              permissions['RocketIdentity.OrganizationUnits']
            "
          >
            <div class="menu-title">其他</div>
            <el-menu-item
              :class="{ isactive: activeRoute == 'position' }"
              index="position"
              v-if="permissions['RocketIdentity.Positions']"
              >职务职级</el-menu-item
            >
            <el-menu-item
              :class="{ isactive: activeRoute == 'organization' }"
              index="organization"
              v-if="permissions['RocketIdentity.OrganizationUnits']"
              >组织架构</el-menu-item
            >
            <!-- <el-menu-item
              :class="{ 'isactive': activeRoute == 'personnelReport' }"
              index="personnelReport"
              >人事报表</el-menu-item
            >
            <el-menu-item
              :class="{ 'isactive': activeRoute == 'report' }"
              index="hrReport"
              >HR统计报表</el-menu-item
            >
            <el-menu-item
              :class="{ 'isactive': activeRoute == 'chart' }"
              index="hrChart"
              >HR图表 V+</el-menu-item
            > -->
          </div>
        </div>
      </el-submenu>
      <el-submenu
        index="report"
        :class="{ isactive: activeIndex == 'report' }"
        v-if="
          permissions['Report.LookEstateReport'] ||
          permissions['Report.LookStoreReport'] ||
          permissions['Report.LookChannelReport'] ||
          permissions['Report.LookChannelReport']
        "
      >
        <template slot="title">
          <div class="menu-title">
            <div class="title-text">智能报表</div>
            <div class="active-line"></div>
          </div>
        </template>
        <div class="menu-box">
          <div class="menu-item">
            <el-menu-item
              v-if="permissions['Report.LookEstateReport']"
              :class="{ isactive: activeRoute == 'estate-report' }"
              index="estateReport"
              >楼盘数据统计</el-menu-item
            >
            <el-menu-item
              v-if="permissions['Report.LookStoreReport']"
              :class="{ isactive: activeRoute == 'store-performance-report' }"
              index="storePerformanceReport"
              >分销商门店业绩报表</el-menu-item
            >
            <el-menu-item
              v-if="permissions['Report.LookChannelReport']"
              :class="{ isactive: activeRoute == 'channel-report' }"
              index="channelReport"
              >渠道数据报表</el-menu-item
            >
            <el-menu-item
              v-if="permissions['Report.LookBrokerReport']"
              :class="{ isactive: activeRoute == 'broker-report' }"
              index="brokerReport"
              >经纪人数据报表</el-menu-item
            >
          </div>
        </div>
      </el-submenu>
      <el-submenu index="system" :class="{ isactive: activeIndex == 'system' }">
        <template slot="title">
          <div class="menu-title">
            <div class="title-text">系统设置</div>
            <div class="active-line"></div>
          </div>
        </template>
        <div class="menu-box">
          <div
            class="menu-item"
            v-if="
              permissions['System.UserSettings'] ||
              permissions['System.OrganizationUnitSettings']
            "
          >
            <div class="menu-title">设置</div>
            <el-menu-item
              v-if="permissions['System.UserSettings']"
              :class="{ isactive: activeRoute == 'setting' }"
              index="systemSetting"
              >基础字段设置</el-menu-item
            >
            <el-menu-item
              v-if="permissions.Area"
              :class="{ isactive: activeRoute == 'area' }"
              index="systemArea"
              >地区管理</el-menu-item
            >
            <el-menu-item
              v-if="permissions['RocketIdentity.Roles']"
              :class="{ isactive: activeRoute == 'permission' }"
              index="systemPermission"
              >权限组管理</el-menu-item
            >
            <el-menu-item
              v-if="permissions['RocketSaas.Tenants']"
              :class="{ isactive: activeRoute == 'tenant' }"
              index="systemTenant"
              >租户管理</el-menu-item
            >
            <el-menu-item
              v-if="permissions['RocketSaas.Editions']"
              :class="{ isactive: activeRoute == 'version' }"
              index="systemVersion"
              >版本管理</el-menu-item
            >
          </div>
          <div class="menu-item">
            <div class="menu-title">工具</div>
            <el-menu-item
              :class="{ isactive: activeRoute == 'approve' }"
              index="systemApprove"
              >登录日志</el-menu-item
            >
            <el-menu-item
              :class="{ isactive: activeRoute == 'message' }"
              index="systemMessage"
              >系统消息</el-menu-item
            >
          </div>
        </div>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import Bus from "@/utils/bus";

export default {
  name: "Navmenu",
  data() {
    return {
      activeIndex: "",
      activeRoute: "",
      permissions: this.$store.getters.permissions,
    };
  },
  methods: {
    showMessage() {
    },
    handleSelect(key, keyPath) {
      this.activeIndex = keyPath[0];
      // let routeData = this.$router.resolve({name: key});
      // window.open(routeData.href, "_blank");
      this.$router.push({ name: key });
    },
    menuInit() {
      let path = this.$route.fullPath;
      this.activeIndex = path.split("/")[1];
      // let el=document.querySelector('.el-menu-item.isactive');
      // if (el) {
      //   el.classList.remove("isactive");
      // }
      this.$nextTick(() => {
        this.activeRoute = path.split("/")[2];
      });
    },
  },
  mounted() {
    this.menuInit();
    Bus.$on("menuInit", this.menuInit);
  },
};
</script>

<style lang="scss" scoped>
.navmenu {
  display: flex;
  align-items: center;

  .logo {
    margin-right: 24px;
    font-size: 109px;
    width: 73px;
    height: 22px;
    color: $--color-primary;
  }
}
</style>